import * as _AuthCode2 from "@shopify/app-bridge-core/actions/AuthCode";
var _AuthCode = "default" in _AuthCode2 ? _AuthCode2.default : _AuthCode2;
import _helper from "../helper";
import _types from "../types";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = exports.Action = exports.respond = void 0;
var AuthCode_1 = _AuthCode;
Object.defineProperty(exports, "Action", {
  enumerable: true,
  get: function () {
    return AuthCode_1.Action;
  }
});
var helper_1 = _helper;
var types_1 = _types;
var AuthCode_2 = _AuthCode;
Object.defineProperty(exports, "respond", {
  enumerable: true,
  get: function () {
    return AuthCode_2.respond;
  }
});
function request(id) {
  return helper_1.actionWrapper({
    group: types_1.Group.AuthCode,
    type: AuthCode_1.Action.REQUEST,
    payload: {
      id: id
    }
  });
}
exports.request = request;
export default exports;
export const __esModule = exports.__esModule,
  Action = exports.Action,
  respond = exports.respond;
const _request = exports.request;
export { _request as request };